import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/paramount/paramount/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "layout"
    }}>{`Layout`}</h1>
    <p>{`Paramount provides building blocks to create responsive layout via components `}<inlineCode parentName="p">{`Visible`}</inlineCode>{`, `}<inlineCode parentName="p">{`Row and Column`}</inlineCode>{`, `}<inlineCode parentName="p">{`Container`}</inlineCode>{` and convenience functions.`}</p>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/paramount/src-components-visible"
        }}>{`Visible`}</a>{` - Conditionally render children depending on screen size`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/paramount/src-components-row-and-column"
        }}>{`Row and Column (Grid)`}</a>{` - For doing grid layouts`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/paramount/src-components-container"
        }}>{`Container`}</a>{` - Keep children at contained width`}</li>
    </ul>
    <h2 {...{
      "id": "hook"
    }}>{`Hook`}</h2>
    <p>{`Paramount exposes a convenience hook `}<inlineCode parentName="p">{`useLayout`}</inlineCode>{` that you can import to make use of utility functions for layout`}</p>
    <h3 {...{
      "id": "currentscreensize"
    }}>{`currentScreenSize`}</h3>
    <p>{`Retrieves the current screen size`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const { currentScreenSize } = useLayout();
`}</code></pre>
    <h3 {...{
      "id": "getresponsivevalue"
    }}>{`getResponsiveValue`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const { getResponsiveValue } = useLayout();

const color = getResponsiveValue({
  xsmall: 'red',
  large: 'blue',
});
const number = getResponsiveValue({
  xsmall: 0,
  large: 1,
});
`}</code></pre>
    <h2 {...{
      "id": "options"
    }}>{`Options`}</h2>
    <p>{`These are all the available theme configuration options, as well as their default values. Pass the config to `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`export const layout: Layout = {
  breakpoints: {
    small: 480,

    medium: 768,

    large: 992,

    xlarge: 1200,
  },
  containerSizes: {
    small: 540,

    medium: 720,

    large: 960,

    xlarge: 1200,
  },
  gridColumnCount: 12,
  gutterWidth: 32,
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      